import { Checkbox, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import dotenv from 'react-dotenv';
import { useDispatch, useSelector } from 'react-redux';
import { getIAAM } from '../../../reducer/iaamSlice';
import { getDisease } from '../../../reducer/diseaseSlice';
import { getWeekOfYear } from '../../../reducer/weekOfYearSlice';
import { setCluster, setClusterChecked } from '../../../reducer/clusterSlice';
import { getAmphurDataMap, getProvinceDataMap, getTambonDataMap } from '../../../reducer/areaDataSlice';
import { getAreaLevel } from '../../../reducer/areaLevelSlice';
import { getDengueSetting, setDengueCluster } from '../../../reducer/dengueSettingSlice';
import dayjs from 'dayjs';

const sizePoint = [3, 9, 15];
const clusterCircleDate = 14;
function ClusterSetting(props) {
    // const {config} = props;
    const dispatch = useDispatch();
    const { cluster } = useSelector(getDengueSetting);
    const provinceMap = useSelector(getProvinceDataMap);
    const amphurMap = useSelector(getAmphurDataMap);
    const tambonMap = useSelector(getTambonDataMap);
    const iaam = useSelector(getIAAM);
    const area_level = useSelector(getAreaLevel);
    const disease_class = useSelector(getDisease);
    const woy = useSelector(getWeekOfYear);
    const [checked, setChecked] = useState(false);


    useEffect(() => {
        const getAPI = async () => {
            let access_token = await iaam.getAccessToken();
            // console.log(access_token);
            // console.log(access_token)
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `bearer ${access_token}`
                }
            }

            // console.log(`${dotenv.SECURE_API_URL}/d506/cluster?disease_class=${disease_class}&start_date=${woy.start.from}&end_date=${woy.end.to}`);

            let res = await iaam.fetch(`${dotenv.SECURE_API_URL}/d506/cluster?disease_class=${disease_class}&start_date=${woy.start.from}&end_date=${woy.end.to}`, options);
            const resData = await res.json();
            // const resData = [
            //     {
            //         "id": "65d906b8-773f-42ae-8013-78d311de45a8",
            //         "disease_class_id": 1,
            //         "tambon_code": "010101",
            //         "treated_date_start": "2026-06-12",
            //         "treated_date_end": "2026-08-17",
            //         "npatients": 10,
            //         "has_secondgen": true,
            //         "cluster_length_day": 67,
            //         "updated_date": "2026-08-23"
            //     },
            //     {
            //         "id": "567cd4c4-b0dc-43b5-9a85-4f86c91966cb",
            //         "disease_class_id": 1,
            //         "tambon_code": "100000",
            //         "treated_date_start": "2026-05-26",
            //         "treated_date_end": "2026-08-15",
            //         "npatients": 15,
            //         "has_secondgen": true,
            //         "cluster_length_day": 82,
            //         "updated_date": "2026-08-23"
            //     },
            //     {
            //         "id": "430c859c-dd42-4a04-b901-d59d6ea88a46",
            //         "disease_class_id": 1,
            //         "tambon_code": "100101",
            //         "treated_date_start": "2026-07-24",
            //         "treated_date_end": "2026-08-10",
            //         "npatients": 2,
            //         "has_secondgen": true,
            //         "cluster_length_day": 18,
            //         "updated_date": "2026-08-23"
            //     }
            // ]

            // let tmpData = {};
            let tmpCluster = {};
            let provAttrName = "prov_namt";
            let provAttrCode = "prov_code";
            let ampAttrName = "amp_namt";
            let ampAttrCode = "amp_code";
            let tambonAttrName = "tambon_namt";
            let tambonAttrCode = "tambon_code";
            for (let index = 0; index < resData.length; index++) {
                const element = resData[index];
                const tambon_code = element.tambon_code;
                const amphur_code = tambon_code.substr(0, 4);
                const province_code = tambon_code.substr(0, 2);
                const tambon = tambonMap[tambon_code];
                const amphur = amphurMap[amphur_code];
                const province = provinceMap[province_code];
                if (tambon !== undefined && amphur !== undefined && province !== undefined) {
                    // let indexSize = parseInt((element.cluster_length_day / clusterCircleDate));
                    let indexSize = parseInt((element.cluster_length_day / 28));
                    if (indexSize > (sizePoint.length - 1)) {
                        indexSize = (sizePoint.length - 1);
                    }
                    const data = {
                        ...element,
                        code: element[tambonAttrCode],
                        name: tambon[tambonAttrName],
                        tambon_name: tambon[tambonAttrName],
                        amphur_code: amphur[ampAttrCode],
                        amphur_name: amphur[ampAttrName],
                        province_code: province[provAttrCode],
                        province_name: province[provAttrName],
                        location: tambon.center_geojson_4326,
                        size: sizePoint[indexSize],
                        cluster_length: Math.ceil((element.cluster_length_day / clusterCircleDate)),
                        zIndex: 30 - indexSize
                    }

                    if (tmpCluster[data[`${area_level}_code`]] === undefined) {
                        tmpCluster[data[`${area_level}_code`]] = [data];
                    } else {
                        let indexOfTambon = tmpCluster[data[`${area_level}_code`]].findIndex(i => i.tambon_code === element[tambonAttrCode]);
                        if (indexOfTambon === -1) {
                            tmpCluster[data[`${area_level}_code`]].push(data);
                        } else {
                            const inArrayData = tmpCluster[data[`${area_level}_code`]][indexOfTambon];
                            const timeInArrayData = dayjs(inArrayData.treated_date_end);
                            const timeData = dayjs(data.treated_date_end);
                            if (timeData.isAfter(timeInArrayData)) {
                                tmpCluster[data[`${area_level}_code`]][indexOfTambon] = data;
                            }
                        }
                        // console.log(tmpCluster[data[`${area_level}_code`]]);
                        // const pos = tmpCluster[data[`${area_level}_code`]].map(e => e.tambon_code).indexOf();
                        // tmpCluster[data[`${area_level}_code`]].push(data);
                    }
                    // console.log(tmpCluster[data[`${area_level}_code`]]);
                }
            }

            // console.log(tmpCluster);

            // for (let index = 0; index < tambonData.length; index++) {
            //     const element = tambonData[index];
            //     const province = 
            //     let clusterData = tmpData[element.tambon_code];
            //     if (clusterData !== undefined) {
            //         delete clusterData.tambon_code;
            //         tmpCluster[element.tambon_code] = {
            //             code: element.tambon_code,
            //             name: element[tambonAttrName],
            //             tambon_code: element.tambon_code,
            //             tambon_name: element[tambonAttrName],
            //             amphur_code: element.amphur_code,
            //             amphur_name: element[ampAttrName],
            //             province_code: element.province_code,
            //             province_name: element[provAttrName],
            //             ...clusterData
            //         }
            //     }
            // }
            dispatch(setCluster(tmpCluster));

        }
        if (iaam) {
            if (checked) {
                dispatch(setCluster({}));
                dispatch(setClusterChecked(true));
                getAPI();
            } else {
                dispatch(setCluster({}));
                dispatch(setClusterChecked(false));
            }
        }
    }, [checked, iaam, area_level, disease_class, woy, dispatch])

    useEffect(() => {
        setChecked(cluster);
    }, [cluster])

    return (
        <>
            <FormControlLabel control={<Checkbox checked={checked} onChange={(event) => {
                dispatch(setDengueCluster(event.target.checked));
                // setChecked(event.target.checked);
            }} />} label="กลุ่มผู้ป่วย & รุ่นการระบาด" />
        </>
    )
}

export default ClusterSetting;